



import React, {
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
    ForwardRefRenderFunction,
  } from "react";
  import Modal from "react-modal";
  import pluseicon from "./../../assets/img/close-circle.svg";
  import { useLoader } from "../../components/loader/loader";
  import { ApiUrl } from "../../config/apiConfig";
  import { postData, uploadImage, uploadvideo } from "../../services/Axios/Axios";
  import messageService from "../../services/message/messageService";
  import { showAPiError_mesage } from "../../services/validationService/validationservice";
  import {
    handleChange,
    handleChange_Radiosingle_button,
  } from "../../services/FormControlService/FormControlServices";
  import { ImagePlus, XCircle } from "lucide-react";

  interface AddTruckProps {
    isOpen: boolean;
    openModal: any;
    closeModal: () => void;
    getDataALLs?: () => void;
  }
  
  const AddMarketNewRelease: ForwardRefRenderFunction<any, AddTruckProps> = (
    props,
    ref
  ) => {
    const { isOpen, openModal, closeModal } = props;
    const { show, hide } = useLoader();
    const refd = useRef<any>(null);
    const [image, setImage] = useState<string>("");
    const [video, setVideo] = useState<string>("");
    const [logo, setLogo] = useState<string>("");
    const [allData, setAllData] = useState([]);

    const [formData, setFormData] = useState<any>({
      display_type: "image",
      display_content: "",
      description: "",
      link: "",
    });
  
    const [error, setError] = useState<{
      [key: string]: string;
    }>({});
  
    useEffect(() => {
      if (openModal) {
        patchData(openModal);
      } else {
        resetForm();
      }
    }, [openModal]);
  
    const customStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        overflow: "unset",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        background: "unset",
        padding: "0",
        border: "none",
        
      },
    };
  
    const patchData = (data: any) => {
      setFormData({
        display_type: data.display_type || "image",
        display_content: data.display_content || "",
        description: data.description || "",
        link: data.link || "",
      });
      setImage(data.image || "");
      setVideo(data.video || "");
      setLogo(data.logo || "");
    };
  
    const hideErrorCustomer = () => {
      resetForm();
      setError({});
    };
  
    const handleKeyDownSpace = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === " " && (e.target as HTMLInputElement).value.length === 0) {
        e.preventDefault();
      }
    };
  
    const save = async () => {
      let isValid = true;
      const newError: { [key: string]: string } = {};
  
      const trimmedData = {
        ...formData,
        link: formData.link.trim(),
        display_content: formData.display_content.trim(),
        description: formData.description.trim(),
        display_type: formData.display_type.trim(),
      };
  
      setFormData(trimmedData);
  
      if (!trimmedData.display_content) {
        newError.display_content = "Required";
        isValid = false;
      }  
  
      if (!trimmedData.link) {
        newError.link = "Link is required";
        isValid = false;
      } else if (!/^https?:\/\/[^\s]+$/.test(trimmedData.link)) {
        newError.link = "Invalid link format";
        isValid = false;
      }  
  
      if (!trimmedData.description) {
        newError.description = "Description is required";
        isValid = false;
      } else if (trimmedData.description.length > 32) {
        newError.description = "Description cannot exceed 32 characters";
        isValid = false;
      }
  
      if (!trimmedData.display_type) {
        newError.display_type = "Required";
        isValid = false;
      }
  
      setError(newError);
  
      if (isValid) {
        try {
          const url = openModal?._id
            ? ApiUrl.addEditNewRelease
            : ApiUrl.addEditNewRelease;
          const response = await postData(
            url,
            { ...trimmedData, _id: openModal?._id },
            { show, hide }
          );

          const messageServicesd = messageService();
          messageServicesd.toast(
            "success",
            openModal?._id
              ? messageServicesd.message.updatedSuccess
              : messageServicesd.message.addedSuccess
          );
  
          closeModal();
          resetForm();
          getdatas();
          if (response?.error?.message) {
            const MessageStore = response?.error?.message;
            showAPiError_mesage(MessageStore);
          }

        } catch (err: any) {
          if (err.response.data.message) {
            const MessageStore =err.response.data.message;
            showAPiError_mesage(MessageStore);
          }
        }
      }
    };
  

    const getdatas = () => {

      props.getDataALLs?.();
  
    };
    const resetForm = () => {
      setFormData({
        display_type: "image", // Reset to "image"
        display_content: "",
        link: "",
        description: "",
      });
      setImage("");
      setVideo("");
      setLogo("");
      // Reset file inputs if necessary
      const imageInput = document.getElementById("image") as HTMLInputElement;
      if (imageInput) imageInput.value = "";
      const videoInput = document.getElementById("video") as HTMLInputElement;
      if (videoInput) videoInput.value = "";
    };
  
    useImperativeHandle(ref, () => ({
      hideErrorCustomer: hideErrorCustomer,
    }));
  
    const selectImage = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files[0]) {
        console.log(event.target.files[0], "imagesall");
        const obj = {
          image: event.target.files[0],
        };
        uploadImages(obj);
      }
    };
  
    const uploadImages = async (obj: any) => {
      console.log(obj, "objimage");
  
      try {
        const response = await uploadImage(ApiUrl.fileUpload, obj ,{ show, hide });
        console.log("Image uploaded successfully:", response);
        setImage(response.original);
  
        updateState({ display_content: response.original });
      } catch (error) {
        console.error("Error uploading image:", error);
      }

      setError((prevError: any) => ({
        ...prevError,
        display_content: "",  
      }));
    };
  
    const uploadVideo = async (obj: any) => {
      try {
        const response = await uploadvideo(ApiUrl.fileUpload, obj,{ show, hide });
        console.log("Video uploaded successfully:", response);
        setVideo(response.original);
        updateState({ display_content: response.original });
      } catch (error) {
        console.error("Error uploading video:", error);
      }
    };
  
    const updateState = (data: any) =>
      setFormData((prev: any) => ({ ...prev, ...data }));
  
    // const removeImage = () => {
    //   setImage("");
    //   updateState({ image: "" });
    //   const inputRef = document.getElementById("image") as HTMLInputElement;
    //   if (inputRef) inputRef.value = "";
    // };
    const removeImage = () => {
 
      setImage("");
    
   
      setFormData((prevData: any) => ({
        ...prevData,
        display_content: "",  
      }));
    
   
   
    
   
      const inputRef = document.getElementById("image") as HTMLInputElement;
      if (inputRef) inputRef.value = "";
    };
  
    const removeVideo = () => {
      setVideo("");
      updateState({ video: "" });
      const inputRef = document.getElementById("video") as HTMLInputElement;
      if (inputRef) inputRef.value = "";
    };
  
    const selectVideo = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files[0]) {
        const obj = {
          video: event.target.files[0],
        };
        uploadVideo(obj);
      }
    };
  
    console.log(image, "formDataformDataformDataformData");
  
    return (

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Add New Release Modal"
        ariaHideApp={false}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        <div className="bg-white !w-[36rem] w-full max-w-3xl rounded-lg shadow-xl">
          {/* Header */}
          <div className="flex justify-between items-center p-4 border-b">
            <h2 className="text-xl font-semibold">
              {openModal?._id ? "Edit New Release" : "Add New Release"}
            </h2>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-700"
              onClick={closeModal}
              aria-label="Close"
            >
              <img src={pluseicon} alt="Close" />
            </button>
          </div>
      
          {/* Form */}
          <form className="space-y-6 p-6">
            {/* Upload Section */}
            <div>
              <label htmlFor="image" className="block text-md font-medium text-gray-700 mb-2">
                Upload Image
              </label>
              <div className="flex items-center justify-center border border-dashed border-gray-300 rounded-md p-6 bg-gray-50 hover:bg-gray-100 transition cursor-pointer">
                {!image ? (
                  <label htmlFor="image" className="flex flex-col items-center space-y-2 cursor-pointer">
                    <ImagePlus className="w-10 h-10 text-gray-400" />
                    <span className="text-gray-600 text-sm">Click to Upload</span>
                  </label>
                ) : (
                  <div className="relative w-full">
                    <img
                      src={image}
                      alt="Uploaded"
                      className="w-full max-h-56 object-contain rounded-md"
                    />
                    <button
                      type="button"
                      onClick={removeImage}
                      className="absolute top-2 right-2 bg-white rounded-full p-1 shadow hover:text-red-600"
                    >
                      <XCircle className="w-6 h-6 text-red-500 hover:text-red-700" />
                    </button>
                  </div>
                )}
                <input
                  type="file"
                  id="image"
                  accept="image/*"
                  onChange={selectImage}
                  className="hidden"
                />
              </div>
              {error.image && <p className="text-red-500 text-sm mt-1">{error.image}</p>}
              {error.display_content && (
                <p className="text-red-500 text-sm mt-1">{error.display_content}</p>
              )}
            </div>
      
            {/* Link Field */}
            <div>
              <label className="block text-md font-medium text-gray-700 mb-1">Reference Link</label>
              <input
                type="text"
                placeholder="https://example.com"
                className="w-full p-2 text-md border border-gray-300 rounded-md hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)] transition-all duration-300"
                value={formData.link}
                name="link"
                onChange={(e) => handleChange(e, setFormData, setError)}
              />
              {error.link && <p className="text-red-500 text-sm">{error.link}</p>}
            </div>
      
            {/* Description */}
            <div>
              <label className="block text-md font-medium text-gray-700 mb-1">
                Short Description (Max 32 characters)
              </label>
              <textarea
                name="description"
                rows={4}
                maxLength={32}
                placeholder="Write here..."
                className="w-full p-2 text-md border border-gray-300 rounded-md hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)] transition-all duration-300 resize-none"
                value={formData.description}
                onChange={(e) => handleChange(e, setFormData, setError)}
              ></textarea>
              {error.description && <p className="text-red-500 text-sm">{error.description}</p>}
              {error.display_type && <p className="text-red-500 text-sm">{error.display_type}</p>}
            </div>
      
            {/* Submit Button */}
            <div className="flex justify-end pt-4 border-t">
              <button
                type="button"
                onClick={save}
                className="px-6 py-2 bg-customOrange text-white rounded-md hover:bg-greenBg duration-300"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </Modal>
      
    );
  };
  
  export default React.forwardRef(AddMarketNewRelease);
  